"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.innerLinerMaterialDefault = exports.grindingTechnologyDefault = exports.beadMaterialTypeDefault = exports.INNER_LINER_MATERIALS = exports.GRINDING_TECHNOLOGIES = exports.BEAD_MATERIAL_TYPES = void 0;
var UNKNOWN = 'UNKNOWN';
var GRINDING_NEOS = 'NEOS';
var GRINDING_NEXWING = 'NEXWING';
var GRINDING_TETRANEX = 'TETRANEX';
var GRINDING_TRINEX = 'TRINEX';
var GRINDING_ZETA = 'ZETA';
var BEAD_MATERIAL_CERA_BEADS = 'CERA_BEADS';
var BEAD_MATERIAL_GLASS_BEADS = 'GLASS_BEADS';
var BEAD_MATERIAL_STEEL_BEADS = 'STEEL_BEADS';
var BEAD_MATERIAL_STEEL_BEADS_HQ = 'STEEL_BEADS_HQ';
var BEAD_MATERIAL_STEEL_BEADS_MICRO = 'STEEL_BEADS_MICRO';
var BEAD_MATERIAL_VITA_BEADS_NANO = 'VITA_BEADS_NANO';
var BEAD_MATERIAL_ZETA_BEADS = 'ZETA_BEADS';
var BEAD_MATERIAL_ZETA_BEADS_NANO = 'ZETA_BEADS_NANO';
var BEAD_MATERIAL_ZETA_BEADS_PLUS = 'ZETA_BEADS_PLUS';
var BEAD_MATERIAL_ZIRCONOX = 'ZIRCONOX';
var BEAD_MATERIAL_ZS_BEADS = 'ZS_BEADS';
var INNER_LINER_MATERIAL_NELAST = 'NELAST';
var INNER_LINER_MATERIAL_NESTEEL_1 = 'NESTEEL_1';
var INNER_LINER_MATERIAL_NESTEEL_2 = 'NESTEEL_2';
var INNER_LINER_MATERIAL_NESTEEL_3 = 'NESTEEL_3';
var INNER_LINER_MATERIAL_NESTEEL_4 = 'NESTEEL_4';
var INNER_LINER_MATERIAL_NESTEEL_5 = 'NESTEEL_5';
var INNER_LINER_MATERIAL_NESTEEL_6 = 'NESTEEL_6';
var INNER_LINER_MATERIAL_NESTEEL_7 = 'NESTEEL_7';
var INNER_LINER_MATERIAL_NESTEEL_8 = 'NESTEEL_8';
var INNER_LINER_MATERIAL_NESTEEL_9 = 'NESTEEL_9';
var INNER_LINER_MATERIAL_NESTEEL_10 = 'NESTEEL_10';
var INNER_LINER_MATERIAL_NESTEEL_11 = 'NESTEEL_11';
var INNER_LINER_MATERIAL_NESTEEL_12 = 'NESTEEL_12';
var INNER_LINER_MATERIAL_NESTEEL_13 = 'NESTEEL_13';
var INNER_LINER_MATERIAL_NESTEEL_14 = 'NESTEEL_14';
var INNER_LINER_MATERIAL_NESTEEL_15 = 'NESTEEL_15';
var INNER_LINER_MATERIAL_NETZSCH_CERAM_A = 'NETZSCH_CERAM_A';
var INNER_LINER_MATERIAL_NETZSCH_CERAM_C = 'NETZSCH_CERAM_C';
var INNER_LINER_MATERIAL_NETZSCH_CERAM_SC = 'NETZSCH_CERAM_SC';
var INNER_LINER_MATERIAL_NETZSCH_CERAM_N = 'NETZSCH_CERAM_N';
var INNER_LINER_MATERIAL_NETZSCH_CERAM_Z = 'NETZSCH_CERAM_Z';
var INNER_LINER_MATERIAL_NELAST_2_90_A = 'NELAST_2_90_A';
var INNER_LINER_MATERIAL_NELAST_10_90_G = 'NELAST_10_90_G';
var INNER_LINER_MATERIAL_NELAST_7_90_C = 'NELAST_7_90_C';
var INNER_LINER_MATERIAL_RUBBER = 'RUBBER';
var INNER_LINER_MATERIAL_WRP = 'WRP';
var GRINDING_TECHNOLOGIES = exports.GRINDING_TECHNOLOGIES = [GRINDING_NEOS, GRINDING_NEXWING, GRINDING_TETRANEX, GRINDING_TRINEX, GRINDING_ZETA];
var BEAD_MATERIAL_TYPES = exports.BEAD_MATERIAL_TYPES = [BEAD_MATERIAL_CERA_BEADS, BEAD_MATERIAL_GLASS_BEADS, BEAD_MATERIAL_STEEL_BEADS, BEAD_MATERIAL_STEEL_BEADS_HQ, BEAD_MATERIAL_STEEL_BEADS_MICRO, BEAD_MATERIAL_VITA_BEADS_NANO, BEAD_MATERIAL_ZETA_BEADS, BEAD_MATERIAL_ZETA_BEADS_NANO, BEAD_MATERIAL_ZETA_BEADS_PLUS, BEAD_MATERIAL_ZIRCONOX, BEAD_MATERIAL_ZS_BEADS];
var INNER_LINER_MATERIALS = exports.INNER_LINER_MATERIALS = [INNER_LINER_MATERIAL_NELAST, INNER_LINER_MATERIAL_NESTEEL_1, INNER_LINER_MATERIAL_NESTEEL_2, INNER_LINER_MATERIAL_NESTEEL_3, INNER_LINER_MATERIAL_NESTEEL_6, INNER_LINER_MATERIAL_NESTEEL_8, INNER_LINER_MATERIAL_NESTEEL_11, INNER_LINER_MATERIAL_NESTEEL_12, INNER_LINER_MATERIAL_NESTEEL_13, INNER_LINER_MATERIAL_NETZSCH_CERAM_A, INNER_LINER_MATERIAL_NETZSCH_CERAM_C, INNER_LINER_MATERIAL_NETZSCH_CERAM_N, INNER_LINER_MATERIAL_NETZSCH_CERAM_Z];
var grindingTechnologyDefault = exports.grindingTechnologyDefault = [{
  value: UNKNOWN,
  name: 'Not implemented'
}, {
  value: GRINDING_NEOS,
  name: 'Neos'
}, {
  value: GRINDING_NEXWING,
  name: 'NexWing®'
}, {
  value: GRINDING_TETRANEX,
  name: 'TetraNex®/TetraNex®+'
}, {
  value: GRINDING_TRINEX,
  name: 'TriNex®'
}, {
  value: GRINDING_ZETA,
  name: 'Zeta®'
}];
var beadMaterialTypeDefault = exports.beadMaterialTypeDefault = [{
  value: UNKNOWN,
  name: 'Not implemented'
}, {
  value: BEAD_MATERIAL_CERA_BEADS,
  name: 'CeraBeads®'
}, {
  value: BEAD_MATERIAL_GLASS_BEADS,
  name: 'GlassBeads®'
}, {
  value: BEAD_MATERIAL_STEEL_BEADS,
  name: 'SteelBeads Q'
}, {
  value: BEAD_MATERIAL_STEEL_BEADS_HQ,
  name: 'SteelBeads HQ'
}, {
  value: BEAD_MATERIAL_STEEL_BEADS_MICRO,
  name: 'SteelBeads Micro'
}, {
  value: BEAD_MATERIAL_VITA_BEADS_NANO,
  name: 'VitaBeads® Nano'
}, {
  value: BEAD_MATERIAL_ZETA_BEADS,
  name: 'ZetaBeads®'
}, {
  value: BEAD_MATERIAL_ZETA_BEADS_NANO,
  name: 'ZetaBeads® Nano'
}, {
  value: BEAD_MATERIAL_ZETA_BEADS_PLUS,
  name: 'ZetaBeads® Plus'
}, {
  value: BEAD_MATERIAL_ZIRCONOX,
  name: 'Zirconox®'
}, {
  value: BEAD_MATERIAL_ZS_BEADS,
  name: 'ZS Beads®'
}];
var innerLinerMaterialDefault = exports.innerLinerMaterialDefault = [{
  value: UNKNOWN,
  name: 'Not implemented'
}, {
  value: INNER_LINER_MATERIAL_NELAST,
  name: 'NElast'
}, {
  value: INNER_LINER_MATERIAL_NESTEEL_1,
  name: 'NESteel 1'
}, {
  value: INNER_LINER_MATERIAL_NESTEEL_2,
  name: 'NESteel 2'
}, {
  value: INNER_LINER_MATERIAL_NESTEEL_3,
  name: 'NESteel 3'
}, {
  value: INNER_LINER_MATERIAL_NESTEEL_4,
  name: 'NESteel 4'
}, {
  value: INNER_LINER_MATERIAL_NESTEEL_5,
  name: 'NESteel 5'
}, {
  value: INNER_LINER_MATERIAL_NESTEEL_6,
  name: 'NESteel 6'
}, {
  value: INNER_LINER_MATERIAL_NESTEEL_7,
  name: 'NESteel 7'
}, {
  value: INNER_LINER_MATERIAL_NESTEEL_8,
  name: 'NESteel 8'
}, {
  value: INNER_LINER_MATERIAL_NESTEEL_9,
  name: 'NESteel 9'
}, {
  value: INNER_LINER_MATERIAL_NESTEEL_10,
  name: 'NESteel 10'
}, {
  value: INNER_LINER_MATERIAL_NESTEEL_11,
  name: 'NESteel 11'
}, {
  value: INNER_LINER_MATERIAL_NESTEEL_12,
  name: 'NESteel 12'
}, {
  value: INNER_LINER_MATERIAL_NESTEEL_13,
  name: 'NESteel 13'
}, {
  value: INNER_LINER_MATERIAL_NESTEEL_14,
  name: 'NESteel 14'
}, {
  value: INNER_LINER_MATERIAL_NESTEEL_15,
  name: 'NESteel 15'
}, {
  value: INNER_LINER_MATERIAL_NETZSCH_CERAM_A,
  name: 'NETZSCH-Ceram A'
}, {
  value: INNER_LINER_MATERIAL_NETZSCH_CERAM_C,
  name: 'NETZSCH-Ceram C'
}, {
  value: INNER_LINER_MATERIAL_NETZSCH_CERAM_SC,
  name: 'NETZSCH-Ceram SC'
}, {
  value: INNER_LINER_MATERIAL_NETZSCH_CERAM_N,
  name: 'NETZSCH-Ceram N'
}, {
  value: INNER_LINER_MATERIAL_NETZSCH_CERAM_Z,
  name: 'NETZSCH-Ceram Z'
}, {
  value: INNER_LINER_MATERIAL_NELAST_2_90_A,
  name: 'NElast 2-90-A'
}, {
  value: INNER_LINER_MATERIAL_NELAST_10_90_G,
  name: 'NElast 10-90-G'
}, {
  value: INNER_LINER_MATERIAL_NELAST_7_90_C,
  name: 'NElast 7-90-C'
}, {
  value: INNER_LINER_MATERIAL_RUBBER,
  name: 'Rubber'
}, {
  value: INNER_LINER_MATERIAL_WRP,
  name: 'WRP'
}];